export default {
  data: () => ({
    page: 0,
    pageSize: 5,
    pageCount: 0,
    allItems: [],
    items: [],
  }),
  methods: {
    setupPagination(allItems) {
      this.allItems = allItems.reduce(
        (arr, item, idx) =>
          idx % this.pageSize === 0
            ? [...arr, [item]]
            : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]],
        []
      )

      this.pageCount = Object.keys(this.allItems).length

      this.items = this.allItems[this.page - 1] || this.allItems[0]
    },
  },
}
